import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { smoothScroll } from 'Common/Utils';
export const SmoothScroll = ({ label, prefixTop = 110, ...props }) => {
	const [animation, setAnimation] = useState(null);

	useEffect(() => () => animation && animation.cancel(), [animation]);

	const handleScroll = (e) => {
		e.preventDefault();
		const animate = smoothScroll(e.currentTarget, prefixTop);

		if (animate) {
			setAnimation(animate);
			const f = (ev) => {
				ev.preventDefault();
			};
			const passive = { passive: false };
			window.addEventListener('mousewheel', f, passive);
			animate.done = () => {
				window.removeEventListener('mousewheel', f, passive);
				document.body.style.willChange = null;
			};
		}
	};

	const handleMouseEnter = () =>
		(document.body.style.willChange = 'scroll-position');

	const handleMouseLeave = () => (document.body.style.willChange = null);

	return (
		<a
			{...props}
			onClick={handleScroll}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}>
			{label}
		</a>
	);
};

SmoothScroll.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	href: PropTypes.string.isRequired,
	prefixTop: PropTypes.number,
};
